import { render, staticRenderFns } from "./FollowPanel.vue?vue&type=template&id=feec37ec&scoped=true"
import script from "./FollowPanel.vue?vue&type=script&lang=js"
export * from "./FollowPanel.vue?vue&type=script&lang=js"
import style0 from "./FollowPanel.vue?vue&type=style&index=0&id=feec37ec&prod&scoped=true&lang=css"
import style1 from "./FollowPanel.vue?vue&type=style&index=1&id=feec37ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feec37ec",
  null
  
)

export default component.exports